import { Component, OnInit } from '@angular/core';
import { MatanotService } from "../matanot.service";
import { Router } from '@angular/router';
import { IEndRishumMatana } from "./end-rishum-matana";

@Component({
    moduleId: module.id,
    templateUrl: './end-rishum-matana.component.html',
    providers: [MatanotService]
})

export class EndRishumMatanaComponent implements OnInit {
    end_rishum: IEndRishumMatana;
    constructor(private _matanotService: MatanotService, private router: Router) { }

    ngOnInit(): void {
        // debugger;
        this._matanotService.getEndRishumMatana()
            .subscribe(e => {
                this.end_rishum = e;
            },
            error => {
                localStorage.removeItem("token");
                location.reload();
            })
    }

    endrishumClicked(event) {
        event.preventDefault();
        localStorage.removeItem("token");
        location.reload();
    }

    updateRishum(event) {
        event.preventDefault();
        this.router.navigateByUrl('/matanot');
    }
}